import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, List, Plus, Settings } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_fintech-notify-check/artifacts/2hk0onm3_My%20Direct%20debit%20reminder%20app%20logo.png";

export function Header({ showUpgrade = false, isPremium = false }) {
  return (
    <header className="glass-header px-4 py-3">
      <div className="max-w-lg mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="header-home-link" aria-label="Go to home page">
          <img src={LOGO_URL} alt="My Direct Debits" className="h-8 w-8 object-contain" />
          <span className="font-heading font-semibold text-dark text-sm">MDD</span>
        </Link>
        {showUpgrade && !isPremium && (
          <Link 
            to="/upgrade"
            data-testid="upgrade-badge"
            className="px-3 py-1 bg-gold-light text-gold text-xs font-semibold rounded-full border border-gold hover:bg-gold hover:text-white transition-colors"
          >
            Upgrade
          </Link>
        )}
      </div>
    </header>
  );
}

export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  
  const navItems = [
    { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/debits', icon: List, label: 'All Debits' },
    { path: '/add', icon: Plus, label: 'Add', isAdd: true },
    { path: '/settings', icon: Settings, label: 'Settings' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-border safe-area-bottom z-50">
      <div className="max-w-lg mx-auto flex items-center justify-around py-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;
          
          if (item.isAdd) {
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                data-testid="add-debit-nav-btn"
                className="flex flex-col items-center justify-center w-14 h-14 -mt-6 bg-primary rounded-full shadow-lg hover:bg-primary-hover transition-colors"
              >
                <Icon className="w-6 h-6 text-white" />
              </button>
            );
          }
          
          return (
            <Link
              key={item.path}
              to={item.path}
              data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
              className={`flex flex-col items-center py-1 px-3 ${
                isActive ? 'text-primary' : 'text-text-light hover:text-text-secondary'
              } transition-colors`}
            >
              <Icon className="w-5 h-5" />
              <span className="text-xs mt-1">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

export function PageLayout({ children, showNav = true, showUpgrade = false, isPremium = false }) {
  return (
    <div className="min-h-screen bg-page">
      <Header showUpgrade={showUpgrade} isPremium={isPremium} />
      <main className={`${showNav ? 'pb-24' : 'pb-8'}`}>
        {children}
      </main>
      {showNav && <BottomNav />}
    </div>
  );
}
